"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9719],{

/***/ 999719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ARROW_POSITION": function() { return /* binding */ ARROW_POSITION; },
/* harmony export */   "ARROW_SHAPE_DROPDOWN": function() { return /* binding */ ARROW_SHAPE_DROPDOWN; },
/* harmony export */   "CARD_SHAPE": function() { return /* binding */ CARD_SHAPE; },
/* harmony export */   "CARD_SHAPE_DROPDOWN": function() { return /* binding */ CARD_SHAPE_DROPDOWN; },
/* harmony export */   "CONTENT_POSITION_TYPE": function() { return /* binding */ CONTENT_POSITION_TYPE; },
/* harmony export */   "DEFAULT_CARD_FRAME_CONFIG": function() { return /* binding */ DEFAULT_CARD_FRAME_CONFIG; },
/* harmony export */   "DEFAULT_CARD_FRAME_CONFIG_CAT": function() { return /* binding */ DEFAULT_CARD_FRAME_CONFIG_CAT; },
/* harmony export */   "DEFAULT_COLLECTION_CARD_IMAGE": function() { return /* binding */ DEFAULT_COLLECTION_CARD_IMAGE; },
/* harmony export */   "DEFAULT_LIST_ARRANGEMENT_PRESENTATION": function() { return /* binding */ DEFAULT_LIST_ARRANGEMENT_PRESENTATION; },
/* harmony export */   "DEFAULT_LIST_ARRANGEMENT_PRESENTATION_CAT": function() { return /* binding */ DEFAULT_LIST_ARRANGEMENT_PRESENTATION_CAT; },
/* harmony export */   "IMAGE_OVERLAY_TOP": function() { return /* binding */ IMAGE_OVERLAY_TOP; },
/* harmony export */   "LIST_ITEM_HEADING": function() { return /* binding */ LIST_ITEM_HEADING; },
/* harmony export */   "LIST_LAYOUT_SELECTABLES": function() { return /* binding */ LIST_LAYOUT_SELECTABLES; },
/* harmony export */   "LIST_TYPE": function() { return /* binding */ LIST_TYPE; },
/* harmony export */   "ListPresentationConfig": function() { return /* binding */ ListPresentationConfig; },
/* harmony export */   "PROGRESS_INDICATOR_DROPDOWN": function() { return /* binding */ PROGRESS_INDICATOR_DROPDOWN; },
/* harmony export */   "TEXT_CASE": function() { return /* binding */ TEXT_CASE; },
/* harmony export */   "TEXT_SIZE_DROPDOWN": function() { return /* binding */ TEXT_SIZE_DROPDOWN; },
/* harmony export */   "TEXT_THICKNESS": function() { return /* binding */ TEXT_THICKNESS; },
/* harmony export */   "Y_ALIGNMENT": function() { return /* binding */ Y_ALIGNMENT; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var src_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(737179);




// Default data for layout and cards
var DEFAULT_LIST_ARRANGEMENT_PRESENTATION = {
    layoutName: "layout1",
    viewLabel: "Collections",
    layoutType: "grid",
    heading: "<h2>Browse the range</h2>",
    headingCharCount: 0,
    description: "",
    descriptionCharCount: 0,
    textAlign: "left",
    colors: {
        selectedColorSchemeIndex: 0,
        colorSchemes: [
            {
                background: "#ffffff",
                text: "#000000",
                isDefault: true
            },
            {
                background: "#000000",
                text: "#ffffff",
                isDefault: false
            }, 
        ]
    },
    openInNewTab: false,
    /* This contains the configs for items that will be rendered in this widget
   * These are inserted from builder UI, where items are chosen selectively */ contentItems: {
        isAllSelected: false,
        type: "collection",
        listItem: []
    },
    numColumnsDesktop: 4,
    numColumnsMobile: 2,
    progressIndicator: "none",
    arrowShape: "circular",
    arrowColor: "#000000",
    shapeColor: "#ffffff",
    arrowPosition: "top",
    progressIndicatorColor: "#000000",
    showArrowInMobile: true,
    mobilePaddingY: 40,
    paddingY: 70,
    marginTop: 0,
    marginBottom: 0,
    /* This is the button that is shown at the bottom of the widget, to redirect to the page where all the items will be shown
   *  like our shop page or collections page or any custom page */ viewAllItemsButtonConfig: [
        (0,src_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultConfig */ ._K)("bannerButton", "#111C36", "#FFFFFF", "See all collections"), 
    ]
};
var DEFAULT_LIST_ARRANGEMENT_PRESENTATION_CAT = {
    layoutName: "layout1",
    viewLabel: "Categories",
    layoutType: "grid",
    heading: "<h2>Browse the range</h2>",
    headingCharCount: 0,
    description: "",
    descriptionCharCount: 0,
    textAlign: "left",
    /* This signifies the color schemes that we follow, for the particular widget, user can create multiple combinations, & user
   *  can later select any one from the list */ colors: {
        selectedColorSchemeIndex: 0,
        colorSchemes: [
            {
                background: "#ffffff",
                text: "#000000",
                isDefault: true
            },
            {
                background: "#000000",
                text: "#ffffff",
                isDefault: false
            }, 
        ]
    },
    // Signifies whether to open the item in a new tab, or redirect in the same tab
    openInNewTab: false,
    contentItems: {
        isAllSelected: false,
        type: "category",
        listItem: []
    },
    numColumnsDesktop: 4,
    numColumnsMobile: 2,
    progressIndicator: "none",
    arrowShape: "circular",
    arrowColor: "#000000",
    shapeColor: "#ffffff",
    arrowPosition: "top",
    progressIndicatorColor: "#000000",
    showArrowInMobile: true,
    mobilePaddingY: 40,
    paddingY: 70,
    marginTop: 0,
    marginBottom: 0,
    viewAllItemsButtonConfig: [
        (0,src_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultConfig */ ._K)("bannerButton", "#111C36", "#FFFFFF", "See all categories"), 
    ]
};
var DEFAULT_CARD_FRAME_CONFIG = {
    cardShape: "portraitShort",
    aspectRatio: "3:4",
    hoverEffect: "zoomIn",
    contentConfig: {
        textConfig: {
            type: "below",
            xAlignment: "center",
            yAlignment: "below",
            textThicness: "regular",
            textSize: "medium",
            textCase: "none",
            overlayOpacity: 1,
            /* As this is inside text config, this is the config of how the item name should look like, the available configs are same
       *  as that of button & item name can be configured similar to a button */ appearanceButton: [
                (0,src_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultConfig */ ._K)("collectionBtn", "#111C36", "#111C36")
            ]
        },
        buttonConfig: [
            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,src_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultConfig */ ._K)("bannerButton", "#FFFFFF", "#111C36", "View products")), {
                isShow: false
            }), 
        ]
    }
};
var DEFAULT_CARD_FRAME_CONFIG_CAT = {
    cardShape: "portraitShort",
    aspectRatio: "3:4",
    hoverEffect: "zoomIn",
    contentConfig: {
        textConfig: {
            type: "below",
            xAlignment: "center",
            yAlignment: "below",
            textThicness: "regular",
            textSize: "medium",
            textCase: "none",
            overlayOpacity: 1,
            appearanceButton: [
                (0,src_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultConfig */ ._K)("collectionBtn", "#111C36", "#111C36")
            ]
        },
        buttonConfig: [
            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,src_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultConfig */ ._K)("bannerButton", "#FFFFFF", "#111C36", "View products")), {
                isShow: false
            }), 
        ]
    }
};
var LIST_LAYOUT_SELECTABLES = [
    {
        name: "layout1",
        cdn: "https://cdn.dotpe.in/longtail/themes/8073865/eVb88qUO.webp",
        // These are the base configs meapped with each layout
        configs: {
            layout: {
                layoutName: "layout1",
                layoutType: "grid"
            },
            card: {
                contentConfig: {
                    buttonConfig: [
                        {
                            isShow: false
                        }
                    ]
                }
            }
        }
    },
    {
        name: "layout2",
        cdn: "https://cdn.dotpe.in/longtail/themes/8073865/VIpuX8Me.webp",
        // These are the base configs mapped with each layout
        configs: {
            layout: {
                layoutName: "layout2",
                layoutType: "carousel"
            },
            card: {
                contentConfig: {
                    buttonConfig: [
                        {
                            isShow: false
                        }
                    ]
                }
            }
        }
    },
    {
        name: "layout3",
        cdn: "https://cdn.dotpe.in/longtail/themes/8073865/PyKLoA0B.webp",
        // These are the base configs mapped with each layout
        configs: {
            layout: {
                layoutName: "layout3",
                layoutType: "grid"
            },
            card: {
                contentConfig: {
                    textConfig: {
                        appearanceButton: [
                            {
                                type: "textual",
                                buttonAnimationConfig: {
                                    classKey: "",
                                    animationName: "None"
                                }
                            }, 
                        ]
                    },
                    buttonConfig: [
                        {
                            isShow: true
                        }
                    ]
                }
            }
        }
    },
    {
        name: "layout4",
        cdn: "https://cdn.dotpe.in/longtail/themes/8073865/sy3HSJmO.webp",
        // These are the base configs mapped with each layout
        configs: {
            layout: {
                layoutName: "layout4",
                layoutType: "carousel"
            },
            card: {
                contentConfig: {
                    textConfig: {
                        appearanceButton: [
                            {
                                type: "textual",
                                buttonAnimationConfig: {
                                    classKey: "",
                                    animationName: "None"
                                }
                            }, 
                        ]
                    },
                    buttonConfig: [
                        {
                            isShow: true
                        }
                    ]
                }
            }
        }
    }, 
];
// Constant and some other data
var POSITIONS_DATA = [
    {
        text: "Left",
        value: "left",
        iconBaseClass: "wb-sprite ic-align-left faded",
        iconActiveClass: "wb-sprite ic-align-left",
        itemLevelClass: "tw-w-[50%]"
    },
    {
        text: "Centre",
        value: "center",
        iconBaseClass: "wb-sprite ic-align-center faded",
        iconActiveClass: "wb-sprite ic-align-center",
        itemLevelClass: "tw-w-[50%]"
    }, 
];
var CARD_TEXT_ALIGNMENT = [
    {
        text: "Left",
        value: "left",
        iconBaseClass: "wb-sprite ic-align-left faded",
        iconActiveClass: "wb-sprite ic-align-left",
        itemLevelClass: "tw-w-[33%]"
    },
    {
        text: "Centre",
        value: "center",
        iconBaseClass: "wb-sprite ic-align-center faded",
        iconActiveClass: "wb-sprite ic-align-center",
        itemLevelClass: "tw-w-[33%]"
    },
    {
        text: "Right",
        value: "right",
        iconBaseClass: "wb-sprite ic-align-right faded",
        iconActiveClass: "wb-sprite ic-align-right",
        itemLevelClass: "tw-w-[33%]"
    }, 
];
var getCardShare = function(text, spiteDetails) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-flex tw-items-center tw-gap-[10px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "wb-sprite ".concat(spiteDetails)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: text
            })
        ]
    });
};
var CARD_SHAPE_DROPDOWN = [
    {
        value: "square",
        renderData: function() {
            return getCardShare("Square (1:1)", "ic-square");
        }
    },
    {
        value: "portraitTall",
        renderData: function() {
            return getCardShare("Portrait tall (2:3)", "ic-PortraitTall");
        }
    },
    {
        value: "portraitShort",
        renderData: function() {
            return getCardShare("Portrait short (3:4)", "ic-PortraitShort");
        }
    },
    {
        value: "landscape",
        renderData: function() {
            return getCardShare("Landscape (3:2)", "ic-landscape");
        }
    },
    {
        value: "landscapeWide",
        renderData: function() {
            return getCardShare("Landscape (4:3)", "ic-landscape2");
        }
    },
    {
        value: "circle",
        renderData: function() {
            return getCardShare("Circle (1:1)", "ic-circle");
        }
    },
    {
        value: "blob",
        renderData: function() {
            return getCardShare("Blob (1:1)", "ic-blob");
        }
    },
    {
        value: "arch",
        renderData: function() {
            return getCardShare("Arch (3:4)", "ic-arch");
        }
    }, 
];
var ARROW_SHAPE_DROPDOWN = [
    {
        value: "circular",
        renderData: function() {
            return getCardShare("Circular", "ic-arrow-circle");
        }
    },
    {
        value: "rounded",
        renderData: function() {
            return getCardShare("Rounded", "ic-arrow-rounded");
        }
    },
    {
        value: "square",
        renderData: function() {
            return getCardShare("Square", "ic-arrow-square");
        }
    }, 
];
var PROGRESS_INDICATOR_DROPDOWN = [
    {
        text: "None",
        value: "none"
    },
    {
        text: "Short progress bar",
        value: "shortProgressBar"
    },
    {
        text: "Full width bar",
        value: "fullWidthBar"
    },
    {
        text: "Dash and dots",
        value: "dashAndDots"
    }, 
];
var TEXT_CASE = [
    {
        text: "Default",
        value: "none",
        itemLevelClass: "tw-w-[33%]"
    },
    {
        text: "Aa",
        value: "capitalize",
        itemLevelClass: "tw-w-[33%]"
    },
    {
        text: "AA",
        value: "uppercase",
        itemLevelClass: "tw-w-[33%]"
    }, 
];
var TEXT_POSITION_DROPDOWN = [
    {
        text: "On card - Top",
        value: "top"
    },
    {
        text: "On card - Middle",
        value: "middle"
    },
    {
        text: "On card - Bottom",
        value: "bottom"
    },
    {
        text: "Below",
        value: "below"
    }, 
];
var ARROW_POSITION = [
    {
        text: "Top",
        value: "top"
    },
    {
        text: "Center",
        value: "center"
    },
    {
        text: "bottom",
        value: "bottom"
    }, 
];
var TEXT_SIZE_DROPDOWN = [
    {
        text: "Extra small (12px)",
        value: "extraSmall",
        itemLevelClass: {
            fontSize: "12px !important"
        }
    },
    {
        text: "Small (14px)",
        value: "small",
        itemLevelClass: {
            fontSize: "14px !important"
        }
    },
    {
        text: "Medium (16px)",
        value: "medium",
        itemLevelClass: {
            fontSize: "16px !important"
        }
    },
    {
        text: "Large (18px)",
        value: "large",
        itemLevelClass: {
            fontSize: "18px !important"
        }
    },
    {
        text: "Extra Large (20px)",
        value: "extraLarge",
        itemLevelClass: {
            fontSize: "20px !important"
        }
    }, 
];
var TEXT_THICKNESS = [
    {
        text: "Thin",
        value: "thin",
        itemLevelClass: {
            fontWeight: "300 !important"
        }
    },
    {
        text: "Regular",
        value: "regular",
        itemLevelClass: {
            fontWeight: "400 !important"
        }
    },
    {
        text: "Medium",
        value: "medium",
        itemLevelClass: {
            fontWeight: "500 !important"
        }
    },
    {
        text: "Semi-bold",
        value: "semiBold",
        itemLevelClass: {
            fontWeight: "600 !important"
        }
    },
    {
        text: "Bold",
        value: "bold",
        itemLevelClass: {
            fontWeight: "700 !important"
        }
    }, 
];
var HOVER_EFFECT_DROPDOWN = [
    {
        text: "Zoom in",
        value: "zoomIn"
    },
    {
        text: "Ambient",
        value: "ambient"
    }, 
];
// Complete config
var ListPresentationConfig = {
    childrenBehaviourConfig: {
        builder: [
            {
                forType: "layout",
                element: "checkbox",
                componentLabel: "On click, Open collections in new tab",
                accessKey: [
                    "openInNewTab"
                ],
                isDynamicLabel: true,
                getDynamicLabel: function(data) {
                    var ref;
                    return (data === null || data === void 0 ? void 0 : (ref = data.contentItems) === null || ref === void 0 ? void 0 : ref.type) === "category" ? "On click, Open category in new tab" : "On click, Open collections in new tab";
                }
            }, 
        ]
    },
    sectionContent: {
        sectionHeading: "Section content",
        description: "",
        tooltipContent: "",
        builder: [
            {
                forType: "layout",
                componentLabel: "Heading",
                element: "inputEditor",
                accessKey: [
                    "heading"
                ],
                charCountKey: "headingCharCount",
                placeholder: "Enter title",
                maxLength: 100
            },
            {
                forType: "layout",
                componentLabel: "Description",
                element: "inputEditor",
                placeholder: "Enter description",
                charCountKey: "descriptionCharCount",
                accessKey: [
                    "description"
                ],
                textColor: "#808080",
                maxLength: 100
            },
            {
                forType: "layout",
                componentLabel: "Section colour",
                editLabel: "Edit colour",
                uniqueKey: "selectionColors",
                element: "colorsCombination",
                accessKey: [
                    "colors"
                ]
            }, 
        ]
    },
    layoutAndDesign: {
        sectionHeading: "Layout & design",
        description: "",
        tooltipContent: "",
        builder: [
            {
                forType: "layout",
                element: "layoutComponent",
                layoutData: LIST_LAYOUT_SELECTABLES,
                modalHeading: "Instagram layout",
                componentLabel: "Desktop Layout",
                // accessKey: ['id'],
                accessKey: [
                    "layoutName"
                ]
            },
            {
                forType: "layoutItem",
                element: "dropdown",
                componentLabel: "Card shape",
                accessKey: [
                    "cardShape"
                ],
                dropdownData: CARD_SHAPE_DROPDOWN,
                customChildRender: true,
                placeholder: ""
            },
            {
                forType: "layout",
                componentLabel: "Content position",
                element: "multiselect",
                accessKey: [
                    "textAlign"
                ],
                componentData: POSITIONS_DATA
            },
            {
                forType: "layout",
                componentLabel: "Number of columns - Desktop",
                element: "slider",
                accessKey: [
                    "numColumnsDesktop"
                ],
                min: 2,
                max: 8,
                suffix: "",
                step: 1
            },
            {
                forType: "layout",
                componentLabel: "Number of columns - Mobile",
                element: "slider",
                accessKey: [
                    "numColumnsMobile"
                ],
                min: 1,
                max: 2,
                suffix: "",
                step: 1
            }, 
        ]
    },
    // carouselSettings: {
    //   sectionHeading: 'Carousel settings',
    //   description: '',
    //   tooltipContent: '',
    //   isVisible: (layout) =>
    //     layout.layoutName === 'layout2' || layout.layoutName === 'layout4',
    //   builder: [
    //     {
    //       forType: 'layout',
    //       element: 'dropdown',
    //       componentLabel: 'Progress indicator',
    //       accessKey: ['progressIndicator'],
    //       dropdownData: PROGRESS_INDICATOR_DROPDOWN,
    //       customChildRender: false,
    //       placeholder: '',
    //     },
    //     {
    //       forType: 'layout',
    //       element: 'dropdown',
    //       componentLabel: 'Arrow shape',
    //       accessKey: ['arrowShape'],
    //       dropdownData: ARROW_SHAPE_DROPDOWN,
    //       customChildRender: true,
    //       placeholder: '',
    //     },
    //     {
    //       forType: 'layout',
    //       element: 'colorDetails',
    //       componentLabel: 'Arrow colour',
    //       colorsData: [
    //         {
    //           text: 'arrowColor',
    //           displayVal: 'Arrow colour',
    //           accessKey: ['arrowColor'],
    //           shouldUpdateData: false,
    //           data: [],
    //         },
    //         {
    //           text: 'shapeColor',
    //           displayVal: 'Shape colour',
    //           accessKey: ['shapeColor'],
    //           shouldUpdateData: false,
    //           data: [],
    //         },
    //       ],
    //     },
    //     {
    //       forType: 'layout',
    //       element: 'colorDetails',
    //       componentLabel: 'Progress indicator color',
    //       colorsData: [
    //         {
    //           text: 'progressIndicatorColor',
    //           displayVal: 'Colour',
    //           accessKey: ['progressIndicatorColor'],
    //           shouldUpdateData: false,
    //           data: [],
    //         },
    //       ],
    //     },
    //     {
    //       forType: 'layout',
    //       element: 'multiselect',
    //       componentLabel: 'Arrow position',
    //       accessKey: ['arrowPosition'],
    //       dynamicData: true,
    //       getDynamicData: (layout, onChange, activeWidgetProps) => {
    //         if (layout?.textAlign === 'left') {
    //           return ARROW_POSITION;
    //         } else {
    //           if (layout?.textAlign === 'left') {
    //             layout.textAlign = 'center';
    //             onChange(activeWidgetProps);
    //           }
    //           if (layout?.textAlign === 'center' && layout?.arrowPosition === 'top') {
    //             layout.arrowPosition = 'center';
    //             onChange(activeWidgetProps);
    //           }
    //           return ARROW_POSITION?.slice(1, 3);
    //         }
    //       },
    //       componentData: ARROW_POSITION,
    //     },
    //     {
    //       forType: 'layout',
    //       element: 'checkbox',
    //       componentLabel: 'Show arrows in mobile',
    //       accessKey: ['showArrowInMobile'],
    //     },
    //   ],
    // },
    viewAllButton: {
        isVisible: function(param) {
            var listPresentation = param.listPresentation;
            return (listPresentation === null || listPresentation === void 0 ? void 0 : listPresentation.layoutName) === "layout1" || (listPresentation === null || listPresentation === void 0 ? void 0 : listPresentation.layoutName) === "layout3";
        },
        builder: [
            {
                forType: "layout",
                element: "button",
                dynamicHeading: true,
                getDynamicButtonHeading: function(activeWidgetProps) {
                    var ref, ref1;
                    return "See all ".concat((activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : (ref1 = ref.contentItems) === null || ref1 === void 0 ? void 0 : ref1.type) === "collection" ? "collections" : "categories");
                },
                subHeading: "This button will be visible when all collections are not in display at front.",
                showColorCombination: true,
                showDeleteIcon: false,
                showRedirectionField: false,
                accessKey: [
                    "viewAllItemsButtonConfig"
                ]
            }, 
        ]
    },
    collectionName: {
        sectionHeading: "Collection name",
        isDynamicHeading: true,
        getDynamicHeading: function(data) {
            var ref;
            return (data === null || data === void 0 ? void 0 : (ref = data.contentItems) === null || ref === void 0 ? void 0 : ref.type) === "category" ? "Category name" : "Collection name";
        },
        description: "",
        tooltipContent: "",
        isShow: true,
        builder: [
            {
                forType: "layoutItem",
                element: "dropdown",
                componentLabel: "Position",
                accessKey: [
                    "contentConfig",
                    "textConfig",
                    "yAlignment"
                ],
                dynamicData: true,
                dynamicDataList: function(activeWidgetProps) {
                    var layout = activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.listPresentation;
                    if (layout.layoutName === "layout3" || layout.layoutName === "layout4") {
                        return TEXT_POSITION_DROPDOWN === null || TEXT_POSITION_DROPDOWN === void 0 ? void 0 : TEXT_POSITION_DROPDOWN.slice(0, (TEXT_POSITION_DROPDOWN === null || TEXT_POSITION_DROPDOWN === void 0 ? void 0 : TEXT_POSITION_DROPDOWN.length) - 1);
                    } else {
                        return TEXT_POSITION_DROPDOWN;
                    }
                },
                customChildRender: false,
                placeholder: ""
            },
            {
                forType: "layoutItem",
                componentLabel: "Text alignment",
                element: "multiselect",
                accessKey: [
                    "contentConfig",
                    "textConfig",
                    "xAlignment"
                ],
                componentData: CARD_TEXT_ALIGNMENT
            },
            {
                forType: "layoutItem",
                element: "dropdown",
                componentLabel: "Text thickness",
                accessKey: [
                    "contentConfig",
                    "textConfig",
                    "textThicness"
                ],
                dropdownData: TEXT_THICKNESS,
                customChildRender: false,
                placeholder: ""
            },
            {
                forType: "layoutItem",
                element: "dropdown",
                componentLabel: "Text size",
                accessKey: [
                    "contentConfig",
                    "textConfig",
                    "textSize"
                ],
                dropdownData: TEXT_SIZE_DROPDOWN,
                customChildRender: false,
                placeholder: ""
            },
            {
                forType: "layoutItem",
                componentLabel: "Text case",
                element: "multiselect",
                accessKey: [
                    "contentConfig",
                    "textConfig",
                    "textCase"
                ],
                componentData: TEXT_CASE
            },
            {
                forType: "layoutItem",
                element: "colorDetails",
                conditionalRender: true,
                isVisible: function(activeWidgetProps) {
                    var ref, ref1;
                    return (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : ref.layoutName) === "layout3" || (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref1 = activeWidgetProps.listPresentation) === null || ref1 === void 0 ? void 0 : ref1.layoutName) === "layout4";
                },
                componentLabel: "",
                colorsData: [
                    {
                        text: "textColor",
                        displayVal: "Name colour",
                        accessKey: [
                            "contentConfig",
                            "textConfig",
                            "appearanceButton",
                            "btnStyleConfig",
                            "textColor", 
                        ],
                        shouldUpdateData: false,
                        data: []
                    }, 
                ]
            },
            {
                forType: "layoutItem",
                componentLabel: "Improve text readability",
                componentSubLabel: "Image overlay",
                element: "slider",
                accessKey: [
                    "contentConfig",
                    "textConfig",
                    "overlayOpacity"
                ],
                min: 1,
                max: 100,
                suffix: "%",
                step: 1
            }, 
        ]
    },
    collectionNameButton: {
        isDynamicHeading: true,
        getDynamicHeading: function(data) {
            var ref;
            return (data === null || data === void 0 ? void 0 : (ref = data.contentItems) === null || ref === void 0 ? void 0 : ref.type) === "category" ? "Category name" : "Collection name";
        },
        description: "",
        tooltipContent: "",
        isVisible: function(activeWidgetProps) {
            var ref, ref1;
            return (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : ref.layoutName) === "layout1" || (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref1 = activeWidgetProps.listPresentation) === null || ref1 === void 0 ? void 0 : ref1.layoutName) === "layout2";
        },
        builder: [
            {
                forType: "layoutItem",
                element: "button",
                buttonHeading: "Collection name appearance",
                dynamicHeading: true,
                getDynamicButtonHeading: function(data) {
                    var ref;
                    return "".concat((data === null || data === void 0 ? void 0 : (ref = data.contentItems) === null || ref === void 0 ? void 0 : ref.type) === "collection" ? "Collection" : "Category", " name appearance");
                },
                showColorCombination: true,
                showDeleteIcon: false,
                showRedirectionField: false,
                showButtonNameField: false,
                showOnOffToggle: false,
                buttonStyleName: "Appearance",
                hoverAnimationName: "Name hover animation",
                buttonColorName: "Name colour",
                accessKey: [
                    "contentConfig",
                    "textConfig",
                    "appearanceButton"
                ]
            }, 
        ]
    },
    collectionButton: {
        isVisible: function(activeWidgetProps) {
            var ref, ref1;
            return (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : ref.layoutName) === "layout3" || (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref1 = activeWidgetProps.listPresentation) === null || ref1 === void 0 ? void 0 : ref1.layoutName) === "layout4";
        },
        builder: [
            {
                forType: "layoutItem",
                element: "button",
                showColorCombination: true,
                showDeleteIcon: false,
                showRedirectionField: false,
                showOnOffToggle: false,
                accessKey: [
                    "contentConfig",
                    "buttonConfig"
                ]
            }, 
        ]
    },
    hoverEffect: {
        sectionHeading: "Hover effect",
        builder: [
            {
                forType: "layoutItem",
                element: "dropdown",
                componentLabel: "Card hover effect",
                accessKey: [
                    "hoverEffect"
                ],
                dropdownData: HOVER_EFFECT_DROPDOWN,
                customChildRender: false,
                placeholder: ""
            }, 
        ]
    },
    sectionSetting: {
        sectionHeading: "Section settings",
        builder: [
            {
                forType: "layout",
                componentLabel: "Desktop padding top and bottom",
                element: "slider",
                accessKey: [
                    "paddingY"
                ],
                min: 0,
                max: 150,
                suffix: "px",
                step: 1
            },
            {
                forType: "layout",
                componentLabel: "Mobile padding top and bottom",
                element: "slider",
                accessKey: [
                    "mobilePaddingY"
                ],
                min: 0,
                max: 100,
                suffix: "px",
                step: 1
            },
            {
                forType: "layout",
                componentLabel: "Margin top",
                element: "slider",
                accessKey: [
                    "marginTop"
                ],
                min: 0,
                max: 100,
                suffix: "px",
                step: 1
            },
            {
                forType: "layout",
                componentLabel: "Margin bottom",
                element: "slider",
                accessKey: [
                    "marginBottom"
                ],
                min: 0,
                max: 100,
                suffix: "px",
                step: 1
            }, 
        ]
    }
};
var CONTENT_POSITION_TYPE = {
    OVERLAY: "overlay",
    BELOW: "below"
};
var LIST_TYPE = {
    COLLECTIONS: "collections",
    CATEGORY: "category"
};
var LIST_ITEM_HEADING = {
    PLP: "Collection in preview",
    PLPCat: "Category in preview",
    collection: "Collections",
    category: "Categories",
    featuredCollection: "Collections",
    featuredTag: "Tags",
    FeaturedCategory: "Category"
};
var CARD_SHAPE = "cardShape";
var Y_ALIGNMENT = "yAlignment";
var IMAGE_OVERLAY_TOP = [
    "top",
    "middle",
    "bottom"
];
var DEFAULT_COLLECTION_CARD_IMAGE = "https://cdn.dotpe.in/longtail/themes/8073865/JXSaayl0.webp";


/***/ })

}]);